import { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Upload, Sparkles } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const readBase64 = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(String(r.result).split(',')[1]);
  r.onerror = reject;
  r.readAsDataURL(file);
});

export const W2UploadPanel = ({ onExtracted }) => {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const extract = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${API}/api/w2/extract`, {
        image_base64: await readBase64(file),
        file_type: file.type.includes('pdf') ? 'pdf' : 'image',
      });
      toast.success('W-2 read successfully');
      onExtracted(res.data.w2);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not read this W-2');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-5 space-y-4" data-testid="w2studio-upload-panel">
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        className={`w-full border-2 border-dashed rounded-xl p-8 text-center transition-colors ${file ? 'border-emerald-500 bg-emerald-500/5' : 'border-zinc-700 hover:border-zinc-500'}`}
        data-testid="w2studio-dropzone"
      >
        <Upload className="w-10 h-10 mx-auto text-zinc-500 mb-2" />
        <p className="text-zinc-300 text-sm">{file ? file.name : 'Click to choose last year\u2019s W-2 (PDF, PNG, JPG)'}</p>
      </button>
      <input ref={inputRef} type="file" accept=".pdf,.png,.jpg,.jpeg" className="hidden"
        onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="w2studio-file-input" />
      <button
        type="button"
        onClick={extract}
        disabled={!file || busy}
        className="w-full h-12 rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white font-semibold flex items-center justify-center gap-2"
        data-testid="w2studio-extract-btn"
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
        {busy ? 'Reading every box…' : 'Read W-2 with AI'}
      </button>
    </div>
  );
};
